<div *ngIf="!isIMDeviceType" class="row mt-3 mb-3 col-12 justify-content-md-center">
	<div class="col-md-12">
		<div class="d-flex justify-content-between">
			<h2>{{'force_read_rt.title' | translate}}</h2>
		</div>
		<div class="form-field mb-2">
			<label for="force_read_rt_time">{{'force_read_rt.sub_title' | translate}}</label>
			<input type="number" class="form-control col-4" [(ngModel)]="force_read_rt_time" [max]="maxRTHours" >
		</div>
		<h6 *ngIf="forceReadRTUntil" class="mt-2">{{'force_read_rt.reading_time_until' | translate}}: <b>{{forceReadRTUntil}} ({{'g.utc' | translate}})</b></h6>
		<div class="my-4">
			<button type="submit" class="btn btn-primary" [disabled]="force_read_rt_time == null" (click)="saveRTDate()">{{'g.submit' | translate}}</button>
		</div>
	</div>
	<div class="col-md-12">
		<mat-icon class="pointer blue-hover button-end" [matMenuTriggerFor]="options" *ngIf="usersService.userHasNOCAccess()">
			cloud_upload
		</mat-icon>
	</div>
</div>

<div class="white-box mt-4 p-4 border-radius">
	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>

	<div *ngIf="isIMDeviceType && imChartFields.length && chartData.length > 0" class="my-5 pt-4">
		<div class="row mb-3">
			<div class="col-md-12">
				<div class="form-check form-check-inline" *ngFor="let field of imChartFields">
					<input class="form-check-input" type="checkbox" [id]="'im-chart-' + field" [(ngModel)]="imVisibleFields[field]" (change)="drawImRTrecordsChart()">
					<label class="form-check-label" [for]="'im-chart-' + field">
						{{getImFieldLabel(field)}}
					</label>
				</div>
			</div>
		</div>
		<div *ngIf="showImChart">
			<sct-charts
				[data]="imChartObject.data"
				[columnNames]="imChartObject.columnNames"
				[options]="imChartObject.config"
				[formatter]="imChartObject.formatter"
				[formatterType]="imChartObject.formatterType"
				[type]="'LineChart'"
				[height]="500"
			></sct-charts>
		</div>
	</div>

	<div *ngIf="showChart" class="mt-5">
		<div class="row">
			<div class="col-md-12">
				<div class="form-check">
					<input class="form-check-input" type="checkbox" value="" id="defaultCheck1" [(ngModel)]="visibilityCheckboxes.voltage" (change)="drawRTrecordsChart()">
					<label class="form-check-label" for="defaultCheck1">
						{{"fleet_reports.show_voltage" | translate}}
					</label>
				</div>
				<div class="form-check">
					<input class="form-check-input" type="checkbox" value="" id="defaultCheck2" [(ngModel)]="visibilityCheckboxes.current" (change)="drawRTrecordsChart()">
					<label class="form-check-label" for="defaultCheck2">
						{{"fleet_reports.show_current" | translate}}
					</label>
				</div>

				<div class="form-check" *ngIf="deviceService.isFWSupportedFeature(device.config_info.fw_version, 'disable_rt_kw')">
					<input class="form-check-input" type="checkbox" value="" id="defaultCheck3" [(ngModel)]="visibilityCheckboxes.kw" (change)="drawRTrecordsChart()">
					<label class="form-check-label" for="defaultCheck3">
						{{'g.show_kw' | translate}}
					</label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="pull-right mr-3">
					<button class="btn fa fa-print fa-lg" printTitle="{{'devices.voltage_and_current_chart' | translate}}" [useExistingCss]="true" printSectionId="voltage-and-current-chart" ngxPrint title="{{'g.print' | translate}}"></button>
				</div>
			</div>
		</div>
		<div id="voltage-and-current-chart" class="row">
			<h2 class="showOnPrint">{{currentSite.customer_name}} / {{currentSite.name}}</h2>
			<h3 class="showOnPrint">{{'devices.voltage_and_current_chart' | translate}}</h3>
			<h4 class="showOnPrint">{{fromDateFormatted}}</h4>
			<h4 class="showOnPrint">{{device.mac_address}} ({{device.serial_number}})</h4>
			<app-print-filters title="devices.voltage_and_current_chart" [filters]="voltageAndCurrentPrintFilters"></app-print-filters>
			<sct-charts
				[data]="chartObject.data"
				[columnNames]="chartObject.columnNames"
				[options]="chartObject.config"
				[formatter]="chartObject.formatter"
				[formatterType]="chartObject.formatterType"
				[title]="'devices.voltage_and_current_chart' | translate"
				[type]="'LineChart'"
				[height]="500"
			></sct-charts>
		</div>

		<!-- SOC -->
		<div class="soc-thresholds-container" *ngIf="showSocChart">
			<div class="soc-threshold-item danger">
				<input
					class="soc-threshold-checkbox"
					type="checkbox"
					id="rtSoc20Line"
					[(ngModel)]="show20PercentLine"
					(change)="drawSocChart()"
				>
				<label class="soc-threshold-label ml-1" for="rtSoc20Line">
					<span class="soc-threshold-dot"></span>
					{{ 'studies.soc_20' | translate}}
				</label>
			</div>

			<div class="soc-threshold-item success">
				<input
					class="soc-threshold-checkbox"
					type="checkbox"
					id="rtSoc80Line"
					[(ngModel)]="show80PercentLine"
					(change)="drawSocChart()"
				>
				<label class="soc-threshold-label ml-1" for="rtSoc80Line">
					<span class="soc-threshold-dot"></span>
					{{ 'studies.soc_80' | translate}}
				</label>
			</div>
		</div>

		<div class="col-1 d-flex  ml-auto mt-3" *ngIf="showSocChart">
			<button class="btn fa fa-print fa-lg" printTitle="{{'exception_reports.battery_%_soc' | translate}}" [useExistingCss]="true" printSectionId="soc-chart" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportRtChartData(socChartObject?.data, 'rt.soc', 'exception_reports.battery_%_soc')"></button>
		</div>

		<div class="row" *ngIf="showSocChart" id="soc-chart">
			<div class="col-12 showOnPrint">
				<h2>{{currentSite.customer_name}} / {{currentSite.name}}</h2>
				<h3>{{'exception_reports.battery_%_soc' | translate}}</h3>
				<h4>{{fromDateFormatted}}</h4>
				<h4>{{device.mac_address}} ({{device.serial_number}})</h4>
			</div>
			<app-print-filters title="exception_reports.battery_%_soc" [filters]="socPrintFilters"></app-print-filters>
			<sct-charts
				[data]="socChartObject.data"
				[columnNames]="socChartObject.columnNames"
				[options]="socChartObject.config"
				[type]="'LineChart'"
				[height]="500">
			</sct-charts>
		</div>

		<!-- Temperature -->
		<div class="row">
			<div class="col-1 d-flex  ml-auto mt-3" *ngIf="showTempChart">
				<button class="btn fa fa-print fa-lg" printTitle="{{'exception_reports.battery_temperature' | translate}}" [useExistingCss]="true" printSectionId="temperature-chart" ngxPrint title="{{'g.print' | translate}}"></button>
				<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportRtChartData(tempChartObject?.data, 'rt.temperature', 'exception_reports.battery_temperature')"></button>
			</div>
		</div>

		<div class="row" *ngIf="showTempChart" id="temperature-chart">
			<div class="col-12 showOnPrint">
				<h2>{{currentSite.customer_name}} / {{currentSite.name}}</h2>
				<h3>{{'exception_reports.battery_temperature' | translate}}</h3>
				<h4>{{fromDateFormatted}}</h4>
				<h4>{{device.mac_address}} ({{device.serial_number}})</h4>
			</div>
			<app-print-filters title="exception_reports.battery_temperature" [filters]="tempPrintFilters"></app-print-filters>
			<sct-charts
				[data]="tempChartObject.data"
				[columnNames]="tempChartObject.columnNames"
				[options]="tempChartObject.config"
				[type]="'LineChart'"
				[height]="500"
			></sct-charts>
		</div>
	</div>
</div>

<app-modal
		[hasConfirmButton]="true"
		[hasCloseButton]="true"
		[closeOnConfirm]="false"
		#fetchRtModal
		[confirmBtnText]="'force_read_rt.fetch_rt_range' | translate"
		[title]="(byId ? 'force_read_rt.fetch_rt_by_id_range' : 'force_read_rt.fetch_rt_time_range') | translate"
		size="lg"
	>
		<!-- by id -->
		<div *ngIf="byId; else byTime">
			<p class="notValidOption" *ngIf="fetchRtBy.id.error">{{fetchRtBy.id.error}}</p>
			<div class="row col-md-12">
				<div class="col-md-6">
					<span>{{'force_read_rt.start_rt_id' | translate}}</span>
					<input type="number" class="form-control" [(ngModel)]="fetchRtBy.id.fromId">
				</div>
				<div class="col-md-6">
					<span>{{'force_read_rt.end_rt_id' | translate}}</span>
					<input type="number" class="form-control" [(ngModel)]="fetchRtBy.id.toId">
				</div>
			</div>
		</div>

		<!-- by time -->
		<ng-template #byTime>
			<p class="notValidOption" *ngIf="fetchRtBy.timeRange.error">{{fetchRtBy.timeRange.error}}</p>
			<div class="row col-md-12">
				<div class="col-md-6">
					<span>{{'g.from_time' | translate}} {{deviceTimeZoneText}}</span>
					<input type="datetime-local" class="form-control" [(ngModel)]="fetchRtBy.timeRange.fromTimeLocal" (ngModelChange)="formatTime('fromTime', $event)">
				</div>
				<div class="col-md-6">
					<span>{{'g.to_time' | translate}} {{deviceTimeZoneText}}</span>
					<input type="datetime-local" class="form-control" [(ngModel)]="fetchRtBy.timeRange.toTimeLocal" (ngModelChange)="formatTime('toTime', $event)">
				</div>
			</div>
		</ng-template>
</app-modal>

<mat-menu #options="matMenu" yPosition="below" [overlapTrigger]="false">
	<ng-template matMenuContent>
		<span mat-menu-item (click)="openFetchRTPopup(true)">{{"force_read_rt.fetch_rt_by_id_range" | translate}}</span>
		<span mat-menu-item (click)="openFetchRTPopup(false)">{{"force_read_rt.fetch_rt_time_range" | translate}}</span>
		<a class="no_decoration_link" mat-menu-item [routerLink]="['/noc-tools', 'rt-requests-history', device.mac_address]">{{'rt_history.history_fetch_rt' | translate}}</a>
	</ng-template>
</mat-menu>
